import { Field, FormikProps, useFormikContext } from 'formik'
import React from 'react'
import { FormSectionTwoColumns } from '../../../../../../../../components/forms/FormSectionTwoColumns'
import { CheckboxInput } from '../../../../../../../../components/inputs/CheckboxInput'
import { RichTextInput } from '../../../../../../../../components/inputs/RichTextInput/RichTextInput'
import { B3_FORM_INITIAL_VALUES } from '../constants'

interface Props {}

export const B31TechnicalSolutionConcept: React.FC<Props> = (props) => {
  const formik = useFormikContext() as FormikProps<typeof B3_FORM_INITIAL_VALUES>
  return (
    <>
      <FormSectionTwoColumns
        sectionKey="b3.overallConceptSolutions"
        title="B.3.1. Celková koncepce stavebně technického a technologického řešení"
        infoContent={
          <div className="text-left">
            <b>Stavebně technické řešení</b>
            <ul className="list-disc pl-5 mb-5">
              <li className="mt-3">
                <b>Zaměření:</b> Popisuje návrh a způsob konstrukce samotné stavby, tedy{' '}
                <b>konstrukční, materiálové a statické řešení budovy</b>.
              </li>
              <li className="mt-3">
                <b>Obsahuje:</b>
                <div className="pl-5 flex flex-col gap-2 mt-2">
                  <p>Návrh základů, stěn, stropů a střechy.</p>
                  <p>Typy a vlastnosti použitých materiálů (např. beton, cihly, dřevo).</p>
                  <p>Dimenze konstrukčních prvků (např. tloušťka stěn, dimenze nosníků).</p>
                  <p>Tepelně-izolační vlastnosti budovy.</p>
                  <p>Řešení hydroizolace, akustiky, požární ochrany apod.</p>
                </div>
              </li>
              <li className="mt-3">
                <b>Cíl:</b> Popsat konstrukční a materiálové vlastnosti budovy tak, aby odpovídaly
                požadavkům na statiku, energetickou náročnost a normy (např. ČSN).
              </li>
            </ul>

            <b>Technologické řešení</b>
            <ul className="list-disc pl-5">
              <li className="mt-3">
                <b>Zaměření:</b> Popisuje <b>způsob realizace stavby</b>, tedy pracovní postupy,
                fáze výstavby a technologie použité při výstavbě.
              </li>
              <li className="mt-3">
                <b>Obsahuje:</b>
                <div className="pl-5 flex flex-col gap-2 mt-2">
                  <p>
                    Postup stavebních prací (např. příprava terénu, výkopové práce, betonování,
                    zdění).
                  </p>
                  <p>
                    Použité stavební technologie (např. montované konstrukce, prefabrikované díly,
                    omítací techniky).
                  </p>
                  <p>Popis stavebního vybavení a strojů (např. jeřáby, míchačky).</p>
                  <p>Opatření pro bezpečnost práce a ochranu životního prostředí při výstavbě.</p>
                </div>
              </li>
              <li className="mt-3">
                <b>Cíl:</b> Zajistit efektivní, bezpečné a kvalitní provedení stavby.
              </li>
            </ul>
          </div>
        }
      >
        <div className="sm:col-span-6 mt-5">
          <Field
            name={`b3.overallConceptSolutions.constructionTechnicalSolution.enabled`}
            component={CheckboxInput}
            label={formik.values.b3.overallConceptSolutions.constructionTechnicalSolution.label}
          />
          {formik.values.b3.overallConceptSolutions.constructionTechnicalSolution.enabled && (
            <>
              <div className="mt-3 pl-7">
                <Field
                  name={`b3.overallConceptSolutions.constructionTechnicalSolution.description`}
                  component={RichTextInput}
                  aiHint={`${formik.values.b3.overallConceptSolutions.constructionTechnicalSolution.label} - popis`}
                />
              </div>
            </>
          )}
        </div>
        <div className="sm:col-span-6 mt-5">
          <Field
            name={`b3.overallConceptSolutions.technologicalSolution.enabled`}
            component={CheckboxInput}
            label={formik.values.b3.overallConceptSolutions.technologicalSolution.label}
          />
          {formik.values.b3.overallConceptSolutions.technologicalSolution.enabled && (
            <>
              <div className="mt-3 pl-7">
                <Field
                  name={`b3.overallConceptSolutions.technologicalSolution.description`}
                  component={RichTextInput}
                  aiHint={`${formik.values.b3.overallConceptSolutions.technologicalSolution.label} - popis`}
                />
              </div>
            </>
          )}
        </div>
      </FormSectionTwoColumns>
    </>
  )
}
